/**
 * Console-local user-facing copy.
 *
 * The "no tenant selected" Empty-state prompt appears on every tenant-scoped
 * page (questions list/detail/create/edit, conference Responses, conference
 * Discovery). The "(top-right)" points at the operate-as-tenant picker, which
 * is a console-only affordance — so this copy stays here, not in the shared
 * @viq-admin/ui, which the portal (no tenant picker) also consumes.
 */
export function selectTenantPrompt(purpose: string): string {
  return `Select a tenant (top-right) to ${purpose}.`;
}
